export { default as Img200 } from './processed/200/EMPIRE_01.jpg';
export { default as Img400 } from './processed/400/EMPIRE_01.jpg';
export { default as Imgthumb } from './processed/thumb/EMPIRE_01.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/EMPIRE_01.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/EMPIRE_01.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      181,
      143,
      75
    ],
    "_population": 1629,
    "_hsl": [
      0.10691823899371068,
      0.4173228346456694,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      237,
      218,
      143
    ],
    "_population": 624,
    "_hsl": [
      0.1329787234042553,
      0.7230769230769232,
      0.7450980392156863
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      101,
      21,
      12
    ],
    "_population": 31,
    "_hsl": [
      0.016853932584269662,
      0.7876106194690266,
      0.22156862745098038
    ]
  },
  "Muted": {
    "_rgb": [
      148,
      140,
      92
    ],
    "_population": 1,
    "_hsl": [
      0.14285714285714288,
      0.2333333333333334,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      164,
      180
    ],
    "_population": 2,
    "_hsl": [
      0.9444444444444445,
      0.35820895522388074,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      53,
      56
    ],
    "_population": 442,
    "_hsl": [
      0.9782608695652174,
      0.17829457364341084,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/EMPIRE_01.js